import * as IsActive from '../../components/is_active'
import * as Modal from '../../components/modal'
import * as Request from '../../request'
import * as FilterGroup from '../filter-group'
import * as Source from '../source-config'
import * as Constants from './constants'
import * as Types from './types'

export const fetchSources: IsActive.FilteredFetcher = IsActive.filteredFetchAction(
  Constants.FETCH_SOURCES,
  Constants.SERVER_RESOURCE,
)

export const toggleImportModal: Modal.Toggle = Modal.toggleModal(Constants.IMPORT_SOURCES)
export const updateImportModalField: Modal.Update = Modal.updateModal(Constants.IMPORT_SOURCES)

export const toggleAddSourceModal: Modal.Toggle = Modal.toggleModal(Constants.ADD_SOURCE)
export const updateAddSourceModalField: Modal.Update = Modal.updateModal(Constants.ADD_SOURCE)

export const toggleAddFilterModal: Modal.Toggle = Modal.toggleModal(Constants.ADD_FILTER)
export const updateAddFilterModalField: Modal.Update = Modal.updateModal(Constants.ADD_FILTER)

export const create: Modal.Submit<Types.AddSourceData> =
  (community: string, data: Types.AddSourceData) =>
  Request.requestActionCreator(Constants.ADD_SOURCE)({
    method: 'POST',
    payload: data,
    url: `${Constants.SERVER_RESOURCE}/${community}`,
  })

export const uploadSourceCsv: Modal.Submit<Types.ImportSourceData> =
  (community: string, payload: Types.ImportSourceData) => {
    return Request.requestActionCreator(Constants.IMPORT_SOURCES)({
      method: 'POST',
      payload: {
        content: payload.content,
        name: payload.name,
      },
      url: `${Constants.SOURCE_IMPORT_SERVER_RESOURCE}/${community}`,
    })
  }

export const updateStatus: IsActive.UpdateStatusAction = (community: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_SOURCE_INLINE)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${Source.SERVER_RESOURCE}/${community}/${stateChange.id}`,
  })

export const createFilterGroup = FilterGroup.createFilterGroupAction(Constants.ADD_FILTER)

export type ExportSourcesAction = Request.RequestAction
export type ExportSources = (communityIdentifier: string) => ExportSourcesAction
export const exportSources: ExportSources = (communityIdentifier: string) =>
  Request.requestActionCreator(Constants.EXPORT_SOURCES)
  ({
    method: 'GET',
    url: `${Constants.SOURCES_SERVER_RESOURCE}/export/${communityIdentifier}`,
  })



// WEBPACK FOOTER //
// ./src/pages/sources/actions.ts